import React, { useState } from "react";
import { cn } from "../../utils/styles";
import { ToolTip } from "./Tooltip";

interface NavButtonProps {
  icon: React.ReactElement;
  title: string;
  isActive?: boolean;
  onClick?: () => void;
  type?: "secondary" | "destructive";
}

export const NavButton = ({ icon, isActive, onClick, title, type }: NavButtonProps) => {
  const [tooltipVisible, setTooltipVisible] = useState(false);

  return (
    <div className="relative">
      <button
        className={cn(
          "relative text-gray-375 p-3 rounded",
          isActive ? "bg-ominimo-400 text-white" : "hover:text-ominimo-400",
          type === "secondary" && !isActive && "hover:bg-gray-100 hover:text-black",
          type === "destructive" && !isActive && "hover:bg-red-100 hover:text-red-500",
        )}
        onClick={onClick}
        onMouseEnter={() => setTooltipVisible(true)}
        onMouseLeave={() => setTooltipVisible(false)}>
        {icon}
      </button>
      {tooltipVisible && <ToolTip text={title} type="nav" destructive={type === "destructive"} />}
    </div>
  );
};
